import ApiService from '@services/api.service'
import storageService from '@services/storage.service'
import { store } from '@state/store'

const SiteService = {
  async getSiteInfoByCSNumber(CsNumber) {
    // Google Analytics/Tag Manager
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ csNumber: CsNumber })
    // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
    let response = await ApiService.get(`/Site/${CsNumber}/BasicInfo`).catch(
      (err) => {
        throw err
      }
    )

    store.updateSiteFromApi(response.data)
    storageService.saveAccount(CsNumber)
  },
}

export default SiteService
